import { render } from "./NotAuthorized.vue?vue&type=template&id=417dcacd"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"

import "./NotAuthorized.vue?vue&type=style&index=0&id=417dcacd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__